import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { childAPI, zoneAPI } from '../../api/client';
import T from '../../theme';

const CHILD_TYPES = [
  { value: 'son', label: "O'g'il", icon: '👦' },
  { value: 'daughter', label: 'Qiz', icon: '👧' },
  { value: 'nephew', label: "Jiyan (o'g'il)", icon: '👦' },
  { value: 'niece', label: 'Jiyan (qiz)', icon: '👧' },
  { value: 'other', label: 'Boshqa', icon: '👶' },
];

export default function AddChildPage() {
  const [step, setStep] = useState(1);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [childName, setChildName] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [childType, setChildType] = useState('son');

  const [imei, setImei] = useState('');
  const [code, setCode] = useState('');

  const [zones, setZones] = useState([]);
  const [selectedZones, setSelectedZones] = useState([]);

  useEffect(() => { zoneAPI.list().then(r => setZones(r.data)).catch(() => {}); }, []);

  const inp = { width: '100%', padding: '15px 18px', background: '#F0FDF4', border: `2px solid ${T.border}`, borderRadius: 14, fontSize: 17, fontFamily: T.font, fontWeight: 600, color: T.text, outline: 'none', transition: 'all 0.3s', boxSizing: 'border-box' };
  const focus = e => { e.target.style.borderColor = T.blue; e.target.style.boxShadow = '0 0 0 3px rgba(16,185,129,0.15)'; };
  const blur = e => { e.target.style.borderColor = T.border; e.target.style.boxShadow = 'none'; };

  const toggleZone = (id) => {
    setSelectedZones(prev => prev.includes(id) ? prev.filter(z => z !== id) : [...prev, id]);
  };

  // Yoshni hisoblash
  const calculateAge = (date) => {
    if (!date) return null;
    const today = new Date();
    const birth = new Date(date);
    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
    return age;
  };

  const handleSubmit = async () => {
    setError(''); setLoading(true);
    try {
      const data = { 
        name: childName, 
        birth_date: birthDate || null, 
        child_type: childType,
        imei: imei,
        security_code: code.replace(/-/g, ''), // Tiresiz yuborish
      };
      if (selectedZones.length > 0) data.zone_ids = selectedZones;
      await childAPI.create(data);
      setStep(4);
    } catch (err) {
      const d = err.response?.data;
      setError(typeof d === 'object' ? Object.values(d).flat().join(', ') : 'Xatolik yuz berdi.');
    }
    setLoading(false);
  };

  const canGoStep2 = childName.trim().length > 0;
  const canGoStep3 = imei.length === 15 && code.replace(/-/g, '').length === 9;

  return (
    <div style={{ minHeight: '100vh', background: T.bg, fontFamily: T.font }}>
      <header style={{ background: '#fff', borderBottom: `2px solid ${T.border}`, padding: '16px 24px', display: 'flex', alignItems: 'center', gap: 12 }}>
        <button onClick={() => navigate('/children')} style={{ background: T.blueSoft, border: 'none', borderRadius: 12, width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: 18 }}>←</button>
        <span style={{ fontSize: 18, fontWeight: 800, color: T.text }}>Bola qo'shish</span>
      </header>
      <div style={{ maxWidth: 480, margin: '0 auto', padding: '32px 20px' }}>
        {/* Progress */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 32 }}>
          {[1, 2, 3, 4].map(s => (
            <React.Fragment key={s}>
              <div style={{
                width: 36, height: 36, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 15, fontWeight: 800,
                background: step >= s ? `linear-gradient(135deg,${T.blue},${T.blueLight})` : '#E5E7EB',
                color: step >= s ? '#fff' : '#9CA3AF',
                boxShadow: step >= s ? '0 4px 12px rgba(16,185,129,0.25)' : 'none',
              }}>{step > s ? '✓' : s}</div>
              {s < 4 && <div style={{ flex: 1, height: 3, borderRadius: 2, background: step > s ? T.blue : '#E5E7EB' }} />}
            </React.Fragment>
          ))}
        </div>

        {/* Step 1: Bola */}
        {step === 1 && (
          <div style={{ background: '#fff', borderRadius: 24, padding: '32px 28px', boxShadow: T.shadow }}>
            <div style={{ textAlign: 'center', marginBottom: 28 }}>
              <div style={{ width: 64, height: 64, borderRadius: 20, background: 'linear-gradient(135deg,#F97316,#F59E0B)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 30, marginBottom: 14 }}>👶</div>
              <h2 style={{ fontSize: 22, fontWeight: 900, color: T.text }}>Bola haqida</h2>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div>
                <label style={{ fontSize: 14, fontWeight: 800, color: T.textSec, display: 'block', marginBottom: 6 }}>BOLA ISMI *</label>
                <input style={inp} value={childName} onChange={e => setChildName(e.target.value)} placeholder="Masalan: Farrux" autoFocus onFocus={focus} onBlur={blur} />
              </div>
              <div>
                <label style={{ fontSize: 14, fontWeight: 800, color: T.textSec, display: 'block', marginBottom: 6 }}>TUG'ILGAN SANA</label>
                <input 
                  style={inp} 
                  type="date" 
                  value={birthDate} 
                  onChange={e => setBirthDate(e.target.value)} 
                  max={new Date().toISOString().split('T')[0]}
                  onFocus={focus} 
                  onBlur={blur} 
                />
                {birthDate && (
                  <div style={{ marginTop: 8, fontSize: 14, color: T.blue, fontWeight: 700 }}>
                    📅 Yoshi: {calculateAge(birthDate)} yosh
                  </div>
                )}
              </div>
              <div>
                <label style={{ fontSize: 14, fontWeight: 800, color: T.textSec, display: 'block', marginBottom: 8 }}>BOLA TURI</label>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
                  {CHILD_TYPES.map(ct => (
                    <button key={ct.value} onClick={() => setChildType(ct.value)} style={{
                      padding: '12px 8px', background: childType === ct.value ? T.blueSoft : '#F9FAFB',
                      border: `2px solid ${childType === ct.value ? T.blue : T.border}`, borderRadius: 12,
                      cursor: 'pointer', fontFamily: T.font, fontSize: 13, fontWeight: 700,
                      color: childType === ct.value ? T.blueDark : T.textSec,
                    }}>
                      <div style={{ fontSize: 22, marginBottom: 4 }}>{ct.icon}</div>{ct.label}
                    </button>
                  ))}
                </div>
              </div>
              <button onClick={() => { if (canGoStep2) setStep(2); }} style={{
                padding: '16px', background: canGoStep2 ? `linear-gradient(135deg,${T.blue},${T.blueLight})` : '#E5E7EB',
                color: canGoStep2 ? '#fff' : '#9CA3AF', border: 'none', borderRadius: 16,
                fontSize: 18, fontWeight: 800, cursor: 'pointer', fontFamily: T.font, marginTop: 8,
              }}>Keyingisi →</button>
            </div>
          </div>
        )}

        {/* Step 2: Qurilma */}
        {step === 2 && (
          <div style={{ background: '#fff', borderRadius: 24, padding: '32px 28px', boxShadow: T.shadow }}>
            <div style={{ textAlign: 'center', marginBottom: 28 }}>
              <div style={{ width: 64, height: 64, borderRadius: 20, background: `linear-gradient(135deg,${T.blue},${T.blueLight})`, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 30, marginBottom: 14 }}>📡</div>
              <h2 style={{ fontSize: 22, fontWeight: 900, color: T.text }}>Qurilma biriktirish</h2>
              <p style={{ fontSize: 14, color: T.textMuted, marginTop: 8 }}>Qurilma qutisidagi IMEI va himoya kodini kiriting</p>
            </div>
            {error && <div style={{ background: '#FEF2F2', color: '#DC2626', padding: '12px 16px', borderRadius: 14, fontSize: 15, fontWeight: 700, textAlign: 'center', marginBottom: 16 }}>⚠️ {error}</div>}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div>
                <label style={{ fontSize: 14, fontWeight: 800, color: T.textSec, display: 'block', marginBottom: 6 }}>IMEI RAQAMI *</label>
                <input style={{ ...inp, fontFamily: T.mono, letterSpacing: 2 }} value={imei} onChange={e => setImei(e.target.value.replace(/\D/g, '').slice(0, 15))} placeholder="000000000000000" maxLength={15} onFocus={focus} onBlur={blur} />
                <div style={{ textAlign: 'right', fontSize: 13, fontWeight: 700, color: imei.length === 15 ? T.blue : T.textMuted, marginTop: 4, fontFamily: T.mono }}>{imei.length}/15</div>
              </div>
              <div>
                <label style={{ fontSize: 14, fontWeight: 800, color: T.textSec, display: 'block', marginBottom: 6 }}>HIMOYA KODI *</label>
                <input 
                  style={{ ...inp, fontFamily: T.mono, letterSpacing: 3, textTransform: 'uppercase' }} 
                  value={code} 
                  onChange={e => {
                    // Faqat harf va raqamlarni olish
                    let val = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 9);
                    // XXX-XXX-XXX formatiga o'zgartirish
                    if (val.length > 6) val = val.slice(0, 3) + '-' + val.slice(3, 6) + '-' + val.slice(6);
                    else if (val.length > 3) val = val.slice(0, 3) + '-' + val.slice(3);
                    setCode(val);
                  }} 
                  placeholder="XXX-XXX-XXX" 
                  maxLength={11} 
                  onFocus={focus} 
                  onBlur={blur} 
                />
                <div style={{ textAlign: 'right', fontSize: 13, fontWeight: 700, color: code.replace(/-/g, '').length === 9 ? T.blue : T.textMuted, marginTop: 4, fontFamily: T.mono }}>{code.replace(/-/g, '').length}/9</div>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
              <button onClick={() => { setStep(1); setError(''); }} style={{ flex: 1, padding: '14px', background: T.bg, border: `2px solid ${T.border}`, borderRadius: 14, fontSize: 16, fontWeight: 700, cursor: 'pointer', color: T.textSec, fontFamily: T.font }}>← Orqaga</button>
              <button onClick={() => { if (canGoStep3) { setError(''); setStep(3); } else { setError("IMEI 15 raqam va kod XXX-XXX-XXX formatida bo'lishi kerak"); } }} style={{
                flex: 2, padding: '14px', background: canGoStep3 ? `linear-gradient(135deg,${T.blue},${T.blueLight})` : '#E5E7EB',
                color: canGoStep3 ? '#fff' : '#9CA3AF', border: 'none', borderRadius: 14,
                fontSize: 18, fontWeight: 800, cursor: 'pointer', fontFamily: T.font,
              }}>Keyingisi →</button>
            </div>
          </div>
        )}

        {/* Step 3: Hududlar */}
        {step === 3 && (
          <div style={{ background: '#fff', borderRadius: 24, padding: '32px 28px', boxShadow: T.shadow }}>
            <div style={{ textAlign: 'center', marginBottom: 28 }}>
              <div style={{ width: 64, height: 64, borderRadius: 20, background: 'linear-gradient(135deg,#3B82F6,#60A5FA)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 30, marginBottom: 14 }}>📍</div>
              <h2 style={{ fontSize: 22, fontWeight: 900, color: T.text }}>Hududlarni biriktiring</h2>
              <p style={{ fontSize: 15, color: T.textSec, marginTop: 6 }}>Bola kuzatiladigan joylarni tanlang</p>
            </div>
            {error && <div style={{ background: '#FEF2F2', color: '#DC2626', padding: '12px 16px', borderRadius: 14, fontSize: 15, fontWeight: 700, textAlign: 'center', marginBottom: 16 }}>⚠️ {error}</div>}

            {zones.length > 0 ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 16 }}>
                {zones.map(z => {
                  const sel = selectedZones.includes(z.id);
                  return (
                    <button key={z.id} onClick={() => toggleZone(z.id)} style={{
                      padding: '14px 16px', background: sel ? (z.color || '#2563EB') + '12' : '#F9FAFB',
                      border: `2px solid ${sel ? z.color || '#2563EB' : T.border}`, borderRadius: 14,
                      cursor: 'pointer', fontFamily: T.font, fontSize: 15, fontWeight: 700,
                      color: sel ? z.color || '#2563EB' : T.textSec, display: 'flex', alignItems: 'center', gap: 12,
                      transition: 'all 0.2s', textAlign: 'left',
                    }}>
                      <span style={{
                        width: 24, height: 24, borderRadius: 7,
                        border: `2px solid ${sel ? z.color || '#2563EB' : '#D1D5DB'}`,
                        background: sel ? z.color || '#2563EB' : '#fff',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 13, color: '#fff', flexShrink: 0,
                      }}>{sel ? '✓' : ''}</span>
                      <span style={{ fontSize: 18, flexShrink: 0 }}>{z.icon}</span>
                      <div>
                        <div>{z.name}</div>
                        {z.address && <div style={{ fontSize: 12, fontWeight: 600, opacity: 0.7 }}>{z.address}</div>}
                      </div>
                    </button>
                  );
                })}
              </div>
            ) : (
              <div style={{ textAlign: 'center', padding: '30px 20px', background: T.bg, borderRadius: 16, marginBottom: 16 }}>
                <p style={{ fontSize: 15, color: T.textMuted }}>Hali hudud qo'shilmagan. Keyinroq sozlasa bo'ladi.</p>
              </div>
            )}

            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => { setStep(2); setError(''); }} style={{ flex: 1, padding: '14px', background: T.bg, border: `2px solid ${T.border}`, borderRadius: 14, fontSize: 16, fontWeight: 700, cursor: 'pointer', color: T.textSec, fontFamily: T.font }}>← Orqaga</button>
              <button onClick={handleSubmit} disabled={loading} style={{
                flex: 2, padding: '14px',
                background: loading ? '#EFF6FF' : `linear-gradient(135deg,${T.blue},${T.blueLight})`,
                color: loading ? T.textSec : '#fff', border: 'none', borderRadius: 14,
                fontSize: 18, fontWeight: 800, cursor: 'pointer', fontFamily: T.font,
              }}>{loading ? 'Saqlanmoqda...' : 'Saqlash ✓'}</button>
            </div>
          </div>
        )}

        {/* Step 4: Success */}
        {step === 4 && (
          <div style={{ background: '#fff', borderRadius: 24, padding: '40px 28px', boxShadow: T.shadow, textAlign: 'center' }}>
            <div style={{ width: 80, height: 80, borderRadius: 24, background: `linear-gradient(135deg,${T.blue},${T.blueLight})`, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 40, marginBottom: 20 }}>✓</div>
            <h2 style={{ fontSize: 26, fontWeight: 900, color: T.text, marginBottom: 10 }}>Muvaffaqiyat! 🎉</h2>
            <p style={{ fontSize: 16, color: T.textSec, lineHeight: 1.8, marginBottom: 28 }}>
              {childName} muvaffaqiyatli qo'shildi.
              <br />Qurilma biriktirildi.
              {selectedZones.length > 0 && <><br />{selectedZones.length} ta hudud biriktirildi.</>}
            </p>
            <button onClick={() => navigate('/children')} style={{
              padding: '16px 40px', background: `linear-gradient(135deg,${T.blue},${T.blueLight})`, color: '#fff',
              border: 'none', borderRadius: 16, fontSize: 18, fontWeight: 800, cursor: 'pointer', fontFamily: T.font,
            }}>Bolalar sahifasiga →</button>
          </div>
        )}
      </div>
    </div>
  );
}
